import { useSelector } from "react-redux";
import ISubCategory from "../menu/categories/ISubCategory";
import APIDefintions from '../../yoello-lib/modules/API2/APIDefs';
import { IReduxAppState } from "../../reducers";
import React, { useReducer } from "react";
import { ITaxesItems, TaxesItems } from "./TaxesItems";
import { menuItemcolumns } from "./columns";
import { ProductContainerReducer } from "../menu/products/state/productContainer.reducer";
import { initalProductState } from '../menu/products/ProductsContainer';
import { setSubCategories } from "../menu/products/state/productContainer.action";
import { useProductsData } from "../menu/products/useProductsData";


export function TaxesMenuItems(props: ITaxesItems) {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const [state, dispatch] = useReducer(ProductContainerReducer, initalProductState);
    
    // eslint-disable-next-line
    const { callAPI: callSubcategory, isLoading: isLoadingSubCatData } = useProductsData<ISubCategory>(
        APIDefintions.menuItemSubcategories, selectedVenueId, (item) => dispatch(setSubCategories(item)), { 'sort_field': 'sort_position' });

    return <TaxesItems {...props} columns={menuItemcolumns}
        taxType="menu_items" itemFilterState={state.subcategories}
        APIDefintion={APIDefintions.menusItems} emptyListTitle="taxes.dialog.emptyList"
        emptyListInfo="taxes.dialog.emptyListInfo" />;
}